import { switchCurrentBoardView } from './switchCurrentBoardView';
import { boardPageState } from './useBoardPageState';

export const returnToBoard = () => {
  if (
    boardPageState.value.secondaryViewParams &&
    boardPageState.value.isShowingOverlay
  ) {
    switchCurrentBoardView({
      routeParams: boardPageState.value.secondaryViewParams,
      navigateOptions: {
        trigger: true,
      },
    });
  } else if (boardPageState.value.primaryViewParams) {
    switchCurrentBoardView({
      routeParams: boardPageState.value.primaryViewParams,
      navigateOptions: {
        trigger: true,
      },
    });
  } else {
    switchCurrentBoardView({
      routeParams: {
        view: 'board',
      },
      navigateOptions: {
        trigger: true,
      },
    });
  }
};
